export type Language = 'pl' | 'en' | 'ru' | 'ua'

export enum SupportedLanguages {
  pl = 'pl',
  en = 'en',
  ru = 'ru',
  ua = 'ua',
}

export const DEFAULT_LANGUAGE: Language = SupportedLanguages.pl

export const LANGUAGE_SUBDOMAINS: Language[] = [
  SupportedLanguages.pl,
  SupportedLanguages.en,
  SupportedLanguages.ru,
  SupportedLanguages.ua,
]

export const isSupportedLanguage = (lang: unknown): lang is Language =>
  typeof lang === 'string' && (Object.values(SupportedLanguages) as string[]).includes(lang)
